import { render, staticRenderFns } from "./inspectionAddPerson.vue?vue&type=template&id=fc15bf46&scoped=true&"
import script from "./inspectionAddPerson.vue?vue&type=script&lang=js&"
export * from "./inspectionAddPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc15bf46",
  null
  
)

export default component.exports